import { memo } from 'react';
import DraggableCard from './dnd-components/DraggableCard';
import ErrorBoundary from './ErrorBoundary';
import CardError from './CardError';
import { useConfigs } from './lib/config-context';
import CardContent from './CardContent';
import { jsx as _jsx } from "react/jsx-runtime";
const ERROR_BOUNDARY_NAME = 'customer-data-board-card-error';
const Card = ({
  cardData,
  columnData,
  index
}) => {
  const {
    onErrorCaught
  } = useConfigs();
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    ErrorComponent: CardError,
    boundaryName: ERROR_BOUNDARY_NAME,
    onComponentDidCatch: error => onErrorCaught && onErrorCaught(ERROR_BOUNDARY_NAME, error),
    children: /*#__PURE__*/_jsx(DraggableCard, {
      cardData: cardData,
      index: index,
      children: /*#__PURE__*/_jsx(CardContent, {
        cardData: cardData,
        columnData: columnData
      })
    })
  });
};
export default /*#__PURE__*/memo(Card);